import { createReducer, on } from '@ngrx/store';

import { BetslipPlaceBetActions } from '../betplacement/actions';
import { BetslipTeaserBetPlaceBetActions } from '../teaser-bet/place-bet.actions';
import { BetslipResultActions } from './actions';
import { defaultResultState } from './state';

export const resultReducer = createReducer(
    defaultResultState,
    on(BetslipPlaceBetActions.placeBetSucceeded, (state, action) => {
        return {
            ...state,
            result: action.result,
        };
    }),
    on(BetslipResultActions.keepPlacedBetsInBetslip, (state, action) => {
        return {
            ...state,
            keepPlacedBetsInBetslip: action.keepPlacedBetsInBetslip,
        };
    }),
    on(BetslipResultActions.keepPlacedBetsInLinearSingle, (state, action) => {
        return {
            ...state,
            keepPlacedBetsInLinearSingle: action.keepPlacedBetsInLinearSingle,
        };
    }),
    on(BetslipResultActions.keepPlacedBetsInLinearCombo, (state, action) => {
        return {
            ...state,
            keepPlacedBetsInLinearCombo: action.keepPlacedBetsInLinearCombo,
        };
    }),
    on(BetslipResultActions.keepPlacedBetsInLinearSystem, (state, action) => {
        return {
            ...state,
            keepPlacedBetsInLinearSystem: {
                ...state.keepPlacedBetsInLinearSystem,
                [action.systemKey]: action.keepPlacedBetsInLinearSystem,
            },
        };
    }),
    on(BetslipResultActions.keepPlacedBetsInLinearBetBuilder, (state, action) => {
        return {
            ...state,
            keepPlacedBetsInLinearBetBuilder: {
                ...state.keepPlacedBetsInLinearBetBuilder,
                [action.groupId]: action.keepPlacedBetsInLinearBetBuilder,
            },
        };
    }),
    on(BetslipResultActions.keepPlacedBetsInLinearTeaser, (state, action) => {
        return {
            ...state,
            keepPlacedBetsInLinearTeaser: action.keepPlacedBetsInLinearTeaser,
        };
    }),
    on(BetslipResultActions.decisionSource, (state, action) => {
        return {
            ...state,
            decisionSource: action.decisionSource,
            isOfferModified: action.isOfferModified,
        };
    }),
    on(BetslipTeaserBetPlaceBetActions.placeBetDone, (state, action) => {
        return {
            ...state,
            result: action.payload[0],
        };
    }),
    on(BetslipResultActions.clearResult, BetslipTeaserBetPlaceBetActions.clearResults, (state, action) => {
        return {
            ...state,
            ...defaultResultState,
        };
    }),
    on(BetslipPlaceBetActions.updateSummaryViewModel, (state, action) => {
        return {
            ...state,
            summary: action.summary,
        };
    }),
    on(BetslipPlaceBetActions.placeBetFailedBetslipResult, (state, action) => {
        return {
            ...state,
            result: {
                ...state.result,
                slips: action.slips,
            },
        };
    }),
);
